/* beadboo theme JS — reveal, collar renderer, hero parallax */
(function () {
  'use strict';

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.bb-rv:not(.bb-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('bb-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('bb-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- bead collar renderer ----------
     <svg class="bb-collar" viewBox="0 0 300 150"
          data-collar='["#hex", ...]' data-tag="MILO ★"></svg> */
  function renderCollar(svg) {
    if (svg.dataset.bbDone) return;
    svg.dataset.bbDone = '1';
    var palette;
    try { palette = JSON.parse(svg.dataset.collar); } catch (e) { return; }
    var tag = svg.dataset.tag || null;
    var vb = svg.viewBox.baseVal, W = vb.width, H = vb.height;
    var NS = 'http://www.w3.org/2000/svg';
    var y0 = H * 0.28, ym = H * 0.62;
    var path = document.createElementNS(NS, 'path');
    path.setAttribute('d', 'M ' + (W * 0.08) + ' ' + y0 + ' Q ' + (W * 0.5) + ' ' + (ym + H * 0.3) + ' ' + (W * 0.92) + ' ' + y0);
    path.setAttribute('stroke', '#2C4770');
    path.setAttribute('stroke-width', '4');
    path.setAttribute('fill', 'none');
    svg.appendChild(path);
    var len = path.getTotalLength();
    var N = 13, r = W / (N * 1.85);
    for (var i = 0; i < N; i++) {
      var p = path.getPointAtLength(len * (0.06 + 0.88 * i / (N - 1)));
      var c = document.createElementNS(NS, 'circle');
      c.setAttribute('cx', p.x); c.setAttribute('cy', p.y); c.setAttribute('r', r);
      c.setAttribute('class', 'bb-bead');
      c.setAttribute('fill', palette[i % palette.length]);
      c.setAttribute('stroke', '#2C4770'); c.setAttribute('stroke-width', '2.5');
      svg.appendChild(c);
      var h = document.createElementNS(NS, 'circle');
      h.setAttribute('cx', p.x - r * 0.3); h.setAttribute('cy', p.y - r * 0.35); h.setAttribute('r', r * 0.22);
      h.setAttribute('fill', 'rgba(255,255,255,.75)');
      svg.appendChild(h);
    }
    if (tag) {
      var mid = path.getPointAtLength(len * 0.5);
      var g = document.createElementNS(NS, 'g');
      g.setAttribute('transform', 'translate(' + (mid.x - 56) + ',' + (mid.y + 10) + ')');
      g.innerHTML =
        '<path d="M14 6 c -8 -12 -22 -2 -12 8 c -10 10 4 20 12 8 h 84 c 8 12 22 2 12 -8 c 10 -10 -4 -20 -12 -8 Z" fill="#FFF7EF" stroke="#2C4770" stroke-width="4"/>' +
        '<text class="bb-tag-name" x="56" y="16" text-anchor="middle" font-family="Titan One, sans-serif" font-weight="400" font-size="16" fill="#2C4770">' + tag + '</text>';
      svg.appendChild(g);
    }
  }
  function initCollars() {
    document.querySelectorAll('svg[data-collar]').forEach(renderCollar);
  }

  /* ---------- hero: beads along the dog's collar arc ---------- */
  function initHeroBeads() {
    document.querySelectorAll('.bb-hero').forEach(function (hero) {
      var arc = hero.querySelector('.bb-collar-arc');
      var g = hero.querySelector('.bb-hero-beads');
      if (!arc || !g || g.dataset.bbDone) return;
      g.dataset.bbDone = '1';
      var NS = 'http://www.w3.org/2000/svg';
      var palette = ['#E85578', '#FFF7EF', '#F7B569', '#6FCFDE', '#F2A9B6'];
      var len = arc.getTotalLength(), N = 13, r = 12;
      for (var i = 0; i < N; i++) {
        var p = arc.getPointAtLength(len * (0.03 + 0.94 * i / (N - 1)));
        var c = document.createElementNS(NS, 'circle');
        c.setAttribute('cx', p.x); c.setAttribute('cy', p.y); c.setAttribute('r', r);
        c.setAttribute('fill', palette[i % palette.length]);
        c.setAttribute('stroke', '#2C4770'); c.setAttribute('stroke-width', '3');
        g.appendChild(c);
        var h = document.createElementNS(NS, 'circle');
        h.setAttribute('cx', p.x - 3.5); h.setAttribute('cy', p.y - 4); h.setAttribute('r', 3);
        h.setAttribute('fill', 'rgba(255,255,255,.8)');
        g.appendChild(h);
      }
    });
  }

  /* ---------- hero parallax: layered, lerped (mouse + scroll) ---------- */
  var parallaxStarted = false;
  function initParallax() {
    if (parallaxStarted) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var hero = document.querySelector('.bb-hero');
    if (!hero) return;
    parallaxStarted = true;
    var dogImg = hero.querySelector('.bb-hero__dog img');
    var tx = 0, ty = 0, cx = 0, cy = 0, sy = 0;
    if (window.matchMedia('(pointer: fine)').matches) {
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        tx = (e.clientX - r.left) / r.width - 0.5;
        ty = (e.clientY - r.top) / r.height - 0.5;
      });
      hero.addEventListener('mouseleave', function () { tx = 0; ty = 0; });
    }
    window.addEventListener('scroll', function () { sy = Math.min(window.scrollY, 900); }, { passive: true });
    (function tick() {
      cx += (tx - cx) * 0.055;
      cy += (ty - cy) * 0.055;
      /* re-query each frame is wasteful; layers are stable per section render */
      var layers = hero.querySelectorAll('[data-depth]');
      layers.forEach(function (el) {
        var d = parseFloat(el.dataset.depth);
        el.style.transform = 'translate3d(' + (cx * d * 38).toFixed(2) + 'px,' + (cy * d * 26 - sy * d * 0.12).toFixed(2) + 'px,0)';
      });
      if (dogImg) {
        dogImg.style.transform =
          'rotateY(' + (cx * 7).toFixed(2) + 'deg) rotateX(' + (-cy * 5).toFixed(2) + 'deg) translate3d(' + (cx * 12).toFixed(2) + 'px,' + (cy * 9 + sy * 0.05).toFixed(2) + 'px,0)';
      }
      requestAnimationFrame(tick);
    })();
  }

  /* ---------- flip-side: drag-to-flip 3D tag with auto-flip ---------- */

  /* Ширина строки текущим шрифтом при 100px через canvas — тот же приём, что в
     кастомайзере (beadboo-customizer.js): getBoundingClientRect тут врёт, потому
     что тег в момент замера может быть повёрнут rotateY. */
  var _fitCanvas = null;
  function bbTextWidth100(el, text) {
    try {
      var cvs = _fitCanvas || (_fitCanvas = document.createElement('canvas'));
      var ctx = cvs.getContext('2d');
      ctx.font = '400 100px ' + getComputedStyle(el).fontFamily;
      return ctx.measureText(text || '').width;
    } catch (e) { return 0; }
  }

  /* Оптический вертикальный центр строки: у bubble-шрифтов верхний запас метрик
     больше нижнего, из-за чего капс «оседает». Возвращаем долю от font-size. */
  function bbVerticalTrim(el, text) {
    try {
      var cvs = _fitCanvas || (_fitCanvas = document.createElement('canvas'));
      var ctx = cvs.getContext('2d');
      ctx.font = '400 100px ' + getComputedStyle(el).fontFamily;
      ctx.textBaseline = 'alphabetic';
      var m = ctx.measureText(text || '');
      var v = (m.fontBoundingBoxAscent - m.fontBoundingBoxDescent - m.actualBoundingBoxAscent + m.actualBoundingBoxDescent) / 2 / 100;
      return isNaN(v) ? 0 : v;
    } catch (e) { return 0; }
  }

  /* Подгон гравировки под косточку: строка держится в ~62% ширины тега (как на
     реальных тегах и в превью товара). Размер считаем в cqw — независимо от того,
     насколько тег отмасштабирован на этой ширине экрана. */
  function bbFitTagText(el) {
    var two = el.classList.contains('bb-flip__text--two');
    var lines = two
      ? [].map.call(el.querySelectorAll('.bb-flip__line'), function (l) { return l.textContent.trim(); })
      : [el.textContent.trim()];
    var longest = lines.reduce(function (a, b) { return b.length > a.length ? b : a; }, '');
    var w100 = bbTextWidth100(el, longest) + Math.max(0, longest.length - 1) * 2; /* +letter-spacing .02em */
    if (!w100) return;
    var fs = Math.min(two ? 15 : 21, Math.max(5, (0.62 * 10000) / w100));
    el.style.setProperty('--bb-fs', fs.toFixed(2));
    /* двухстрочный телефон центрируем геометрически — сдвиг считаем только для строки */
    var k = two ? 0 : bbVerticalTrim(el, longest);
    el.style.setProperty('--bb-vshift', (-k * fs).toFixed(3) + 'cqw');
  }

  function initFlipTag() {
    document.querySelectorAll('.bb-flip').forEach(function (wrap) {
      if (wrap.dataset.bbDone) return;
      wrap.dataset.bbDone = '1';
      var card = wrap.querySelector('.bb-flip__card');
      if (!card) return;
      var rot = 0, dragging = false, startX = 0, startRot = 0, auto = null, moved = false;

      var texts = [].slice.call(wrap.querySelectorAll('[data-bb-fit]'));
      function fitAll() { texts.forEach(bbFitTagText); }
      fitAll();
      /* шрифт мог ещё не догрузиться — пересчитать по факту загрузки */
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
      if (document.fonts && document.fonts.addEventListener) {
        document.fonts.addEventListener('loadingdone', fitAll);
      }

      function render() { card.style.transform = 'rotateY(' + rot + 'deg)'; }
      function animateTo(t) {
        card.style.transition = 'transform .9s cubic-bezier(.34, 1.25, .4, 1)';
        rot = t; render();
      }
      function startAuto() {
        clearInterval(auto);
        auto = setInterval(function () {
          if (!dragging) animateTo(rot + 180);
        }, 4500);
      }

      wrap.addEventListener('pointerdown', function (e) {
        dragging = true; moved = false;
        startX = e.clientX; startRot = rot;
        card.style.transition = 'none';
        wrap.classList.add('is-dragging'); /* пауза idle-покачивания, пока тянут */
        clearInterval(auto);
        try { wrap.setPointerCapture(e.pointerId); } catch (err) {}
      });
      wrap.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        rot = startRot + dx * 0.55;
        render();
      });
      function release() {
        if (!dragging) return;
        dragging = false;
        wrap.classList.remove('is-dragging');
        var snapped = Math.round(rot / 180) * 180;
        if (!moved) snapped = snapped + 180; /* tap = flip */
        animateTo(snapped);
        startAuto();
      }
      wrap.addEventListener('pointerup', release);
      wrap.addEventListener('pointercancel', release);

      render();
      startAuto();
    });
  }

  /* ---------- «летающая» карусель (float_mode у beadboo-shop, 2026-09-23) ----------
     Перенос 1:1 утверждённого прототипа output/float-carousel-2026-09-23/index.html:
     раскладку считаем от ширины сцены (центр / соседи ±gap со scale .52 и blur 1.5 /
     дальние уходят за край), выбранный ошейник «прилетает» со спином по направлению,
     свечение за ним — цвет стиля (data-glow), чармы сдвигаются за курсором (параллакс). */
  function initFly() {
    document.querySelectorAll('[data-bb-fly]').forEach(function (root) {
      if (root.dataset.bbDone) return;
      root.dataset.bbDone = '1';
      var stage = root.querySelector('.bb-fly__stage');
      var els = [].slice.call(root.querySelectorAll('.bb-fly__item'));
      var N = els.length; if (!N) return;
      var glow = root.querySelector('.bb-fly__glow');
      var dots = root.querySelector('.bb-fly__dots');
      var nameEl = root.querySelector('[data-bb-look-name]');
      var priceEl = root.querySelector('[data-bb-look-price]');
      var wasEl = root.querySelector('[data-bb-look-was]');
      var ctaEl = root.querySelector('[data-bb-look-cta]');
      var cur = 0, busy = false, moved = false;
      var offTo = function (i) { var o = ((i - cur) % N + N) % N; return o <= N / 2 ? o : o - N; };

      els.forEach(function (el, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'bb-fly__dot'; b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', el.dataset.name || 'Style ' + (i + 1));
        var img = el.querySelector('img');
        if (img) { var mini = img.cloneNode(); mini.alt = ''; mini.sizes = '54px'; mini.loading = 'lazy'; b.appendChild(mini); }
        b.addEventListener('click', function () { var o = offTo(i); if (o) go(o); });
        dots.appendChild(b);
        /* центральный — обычная ссылка на стиль; боковой подъезжает в центр */
        el.addEventListener('click', function (e) {
          if (moved) { e.preventDefault(); return; }
          var o = offTo(i);
          if (o !== 0 && e.detail !== 0) { e.preventDefault(); go(o); }
        });
      });

      function layout(dir) {
        var w = stage.clientWidth, gap = Math.min(w * .37, 420), far = Math.min(w * .62, 680), narrow = w < 640;
        els.forEach(function (el, i) {
          var s = offTo(i), a = Math.abs(s);
          var tx = Math.sign(s) * (a === 0 ? 0 : a === 1 ? (narrow ? w * .44 : gap) : far);
          var sc = a === 0 ? 1 : a === 1 ? (narrow ? .42 : .52) : .32;
          var op = a === 0 ? 1 : a === 1 ? .62 : 0, bl = a === 0 ? 0 : a === 1 ? (narrow ? 4 : 1.5) : 3, /* мобилка: соседи мутнее (Илья 09-23) */ ty = a === 0 ? 0 : -(a * 26);
          el.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + sc + ')';
          el.style.opacity = op; el.style.filter = 'blur(' + bl + 'px)'; el.style.zIndex = 10 - a;
          el.style.pointerEvents = a > 1 ? 'none' : 'auto';
          el.tabIndex = a > 1 ? -1 : 0;
          if (a > 1) el.setAttribute('aria-hidden', 'true'); else el.removeAttribute('aria-hidden');
        });
        var it = els[cur];
        if (nameEl) {
          var apply = function () {
            nameEl.textContent = it.dataset.name || '';
            if (it.dataset.handle) nameEl.setAttribute('data-bb-handle', it.dataset.handle);
            nameEl.classList.remove('bb-fly-swap');
          };
          if (dir) { nameEl.classList.add('bb-fly-swap'); setTimeout(apply, 220); } else apply();
        }
        if (priceEl) priceEl.textContent = it.dataset.price || '';
        if (wasEl) { wasEl.textContent = it.dataset.was || ''; wasEl.hidden = !it.dataset.was; }
        if (ctaEl) ctaEl.href = it.getAttribute('href');
        if (glow) glow.style.setProperty('--glow', it.dataset.glow || 'rgba(232,85,120,.13)');
        [].forEach.call(dots.children, function (b, i) { b.classList.toggle('bb-on', i === cur); b.setAttribute('aria-selected', i === cur ? 'true' : 'false'); });
      }
      function go(step) {
        if (busy) return; busy = true;
        cur = ((cur + step) % N + N) % N;
        var el = els[cur];
        el.style.setProperty('--spin', (step > 0 ? -16 : 16) + 'deg');
        el.classList.remove('is-launch'); void el.offsetWidth; el.classList.add('is-launch');
        layout(step); setTimeout(function () { busy = false; }, 520);
      }
      root.querySelector('.bb-fly__arrow--l').addEventListener('click', function () { go(-1); });
      root.querySelector('.bb-fly__arrow--r').addEventListener('click', function () { go(1); });
      /* свайп: порог 40px; после свайпа клик по ссылке под пальцем гасим */
      var x0 = null;
      stage.addEventListener('pointerdown', function (e) { x0 = e.clientX; moved = false; });
      window.addEventListener('pointerup', function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) { moved = true; go(dx < 0 ? 1 : -1); setTimeout(function () { moved = false; }, 60); }
      });
      stage.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = stage.getBoundingClientRect(), mx = (e.clientX - r.left) / r.width - .5, my = (e.clientY - r.top) / r.height - .5;
        stage.querySelectorAll('.bb-fly__charm').forEach(function (c) { var k = +c.dataset.depth; c.style.translate = (-mx * k) + 'px ' + (-my * k) + 'px'; });
      });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') go(1);
        if (e.key === 'ArrowLeft') go(-1);
      });
      window.addEventListener('resize', function () { layout(); });
      layout();
    });
  }

  /* ---------- shop the looks: 3-position carousel ---------- */
  function initLooks() {
    document.querySelectorAll('.bb-looks__showcase').forEach(function (root) {
      if (root.dataset.bbDone) return;
      root.dataset.bbDone = '1';
      var stage = root.querySelector('.bb-looks__stage');
      var looks = [].slice.call(root.querySelectorAll('.bb-look'));
      var thumbsWrap = root.querySelector('.bb-looks__thumbs');
      var nameEl = root.querySelector('[data-bb-look-name]');
      var priceEl = root.querySelector('[data-bb-look-price]');
      var ctaEl = root.querySelector('[data-bb-look-cta]');
      var propWraps = [].slice.call(root.querySelectorAll('.bb-prop'));
      if (!looks.length || !thumbsWrap) return;
      var n = looks.length;
      var current = 0, auto = null;
      var speed = (parseFloat(root.dataset.speed) || 3) * 1000;

      /* build swatch thumbs from the figures */
      looks.forEach(function (look, i) {
        var btn = document.createElement('button');
        btn.className = 'bb-looks__thumb';
        btn.type = 'button';
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', look.dataset.name || 'Look ' + (i + 1));
        var span = document.createElement('span');
        var img = look.querySelector('img');
        if (img) {
          var mini = img.cloneNode();
          mini.removeAttribute('srcset'); mini.removeAttribute('sizes');
          mini.loading = 'lazy';
          span.appendChild(mini);
        } else {
          var pal;
          try { pal = JSON.parse(look.dataset.pal || '[]'); } catch (e) { pal = []; }
          if (pal.length >= 3) {
            span.style.background = 'conic-gradient(' + pal[0] + ' 0 33%, ' + pal[1] + ' 33% 66%, ' + pal[2] + ' 66% 100%)';
          } else {
            span.style.background = pal[0] || '#F2A9B6';
          }
        }
        btn.appendChild(span);
        btn.addEventListener('click', function () { show(i); restartAuto(); });
        thumbsWrap.appendChild(btn);
      });
      var thumbs = [].slice.call(thumbsWrap.children);

      /* боковая карточка — подводим в центр (ссылку гасим);
         центральная работает как обычная ссылка на страницу стиля.
         e.detail === 0 = клик с клавиатуры (Enter) — там ссылку не трогаем,
         иначе Tab+Enter требовал бы двух нажатий. */
      looks.forEach(function (look, i) {
        look.addEventListener('click', function (e) {
          var side = look.classList.contains('bb-pos-prev') || look.classList.contains('bb-pos-next');
          if (side && e.detail !== 0) {
            e.preventDefault();
            show(i); restartAuto();
          }
        });
      });

      function layout() {
        looks.forEach(function (l, j) {
          l.classList.remove('bb-pos-active', 'bb-pos-prev', 'bb-pos-next');
          /* inline-стили драга не должны перебивать классы позиций */
          l.style.transform = '';
          l.style.opacity = '';
          var d = (j - current + n) % n;
          var activeImg = l.querySelector('img, svg');
          if (activeImg) activeImg.style.transform = '';
          if (d === 0) l.classList.add('bb-pos-active');
          else if (d === 1 && n > 1) l.classList.add('bb-pos-next');
          else if (d === n - 1 && n > 2) l.classList.add('bb-pos-prev');
          /* спрятанные карточки (opacity:0) не должны ловить Tab */
          var link = l.querySelector('.bb-look__link');
          if (link) {
            var visible = l.classList.contains('bb-pos-active')
              || l.classList.contains('bb-pos-prev')
              || l.classList.contains('bb-pos-next');
            link.tabIndex = visible ? 0 : -1;
            if (visible) l.removeAttribute('aria-hidden');
            else l.setAttribute('aria-hidden', 'true');
          }
        });
      }

      /* ── свайп пальцем с follow-анимацией (2026-08-25, Илья: «плавно тянуло
         влево и картинка уходила влево», а не только тап по соседней) ──
         Во время драга три карточки интерполируются между своими базовыми
         позициями (значения синхронны с CSS .bb-pos-*: десктоп ±92%/.58,
         ≤620px ±78%/.45); отпустил — порог 28% ширины или флик по скорости
         решают, листаем или пружиним назад. Вертикальный жест отдаём странице
         (touch-action: pan-y в CSS). */
      if (stage && n > 1 && window.PointerEvent) {
        var drag = null;
        var suppressClick = false;
        var mqNarrow = window.matchMedia('(max-width: 620px)');
        var lookAt = function (off) { return looks[(current + off + n) % n]; };
        var applyDrag = function (p) {
          var S = mqNarrow.matches ? 78 : 92;
          var sc = mqNarrow.matches ? 0.45 : 0.58;
          var abs = Math.abs(p);
          var act = lookAt(0);
          var nxt = n > 1 ? lookAt(1) : null;
          var prv = n > 2 ? lookAt(-1) : null;
          act.style.transform = 'translate(-50%, -50%) translateX(' + (-p * S) + '%) scale(' + (1 - (1 - sc) * abs) + ') rotate(' + (p * 4) + 'deg)';
          act.style.opacity = '';
          if (nxt && nxt !== act) {
            var pn = Math.max(0, p);
            nxt.style.transform = 'translate(-50%, -50%) translateX(' + (S - pn * S) + '%) scale(' + (sc + (1 - sc) * pn) + ') rotate(' + (4 - pn * 8) + 'deg)';
            nxt.style.opacity = String(0.55 + 0.45 * pn);
          }
          if (prv && prv !== act && prv !== nxt) {
            var pp = Math.max(0, -p);
            prv.style.transform = 'translate(-50%, -50%) translateX(' + (-S + pp * S) + '%) scale(' + (sc + (1 - sc) * pp) + ') rotate(' + (-4 + pp * 8) + 'deg)';
            prv.style.opacity = String(0.55 + 0.45 * pp);
          }
        };
        stage.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          drag = {
            x: e.clientX, y: e.clientY, t: e.timeStamp, p: 0, active: false,
            w: stage.getBoundingClientRect().width || 1,
          };
        });
        stage.addEventListener('pointermove', function (e) {
          if (!drag) return;
          var dx = e.clientX - drag.x;
          var dy = e.clientY - drag.y;
          if (!drag.active) {
            if (Math.abs(dx) < 7) return;
            if (Math.abs(dy) > Math.abs(dx) * 1.2) { drag = null; return; }
            drag.active = true;
            stage.classList.add('is-dragging');
            try { stage.setPointerCapture(e.pointerId); } catch (err) { /* iOS quirk */ }
            clearInterval(auto);
          }
          drag.p = Math.max(-1, Math.min(1, -dx / (drag.w * 0.7)));
          applyDrag(drag.p);
        });
        var endDrag = function (e) {
          if (!drag) return;
          var wasActive = drag.active;
          var p = drag.p || 0;
          var dt = (e.timeStamp - drag.t) || 1;
          var vx = (e.clientX - drag.x) / dt; /* px/ms, влево = минус */
          stage.classList.remove('is-dragging');
          drag = null;
          if (!wasActive) return;
          suppressClick = true;
          setTimeout(function () { suppressClick = false; }, 120);
          if (p > 0.28 || vx < -0.45) show(current + 1);
          else if (p < -0.28 || vx > 0.45) show(current - 1);
          else layout(); /* не дотянул — пружиним на место */
          restartAuto();
        };
        stage.addEventListener('pointerup', endDrag);
        stage.addEventListener('pointercancel', endDrag);
        /* драг не должен превращаться в клик по карточке под пальцем */
        stage.addEventListener('click', function (e) {
          if (suppressClick) { e.preventDefault(); e.stopPropagation(); }
        }, true);
      }

      function show(i, silent) {
        current = ((i % n) + n) % n;
        layout();
        thumbs.forEach(function (t, j) { t.classList.toggle('bb-on', j === current); });
        if (nameEl) {
          nameEl.textContent = looks[current].dataset.name || '';
          /* голос стиля (STYLE VOICES): карта шрифта/цвета в beadboo.css
             живёт на data-bb-handle — прокидываем handle слайда */
          if (looks[current].dataset.handle) nameEl.setAttribute('data-bb-handle', looks[current].dataset.handle);
          else nameEl.removeAttribute('data-bb-handle');
          nameEl.classList.remove('bb-swap');
          void nameEl.offsetWidth;
          nameEl.classList.add('bb-swap');
        }
        if (priceEl && looks[current].dataset.price) priceEl.textContent = looks[current].dataset.price;
        /* перечёркнутый compare-at рядом с ценой (2026-08-25, Илья: скидку
           должно быть видно везде) */
        var wasEl = root.querySelector('[data-bb-look-was]');
        if (wasEl) {
          var was = looks[current].dataset.was || '';
          wasEl.textContent = was;
          wasEl.hidden = !was;
        }
        if (ctaEl && looks[current].dataset.url) ctaEl.href = looks[current].dataset.url;
      }

      function restartAuto() {
        clearInterval(auto);
        auto = setInterval(function () { show(current + 1); }, speed);
      }

      show(0, true);
      restartAuto();
      /* pause while the pointer is over the stage */
      root.addEventListener('mouseenter', function () { clearInterval(auto); });
      root.addEventListener('mouseleave', restartAuto);

      /* scroll-driven spin & drift: props follow the page scroll,
         only while this section is on screen */
      if (propWraps.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var section = root.closest('.bb-looks') || root;
        var inView = false, scrollRaf = null;
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { inView = en.isIntersecting; });
          }, { rootMargin: '10% 0px' }).observe(section);
        } else { inView = true; }

        function onScroll() {
          if (!inView || scrollRaf) return;
          scrollRaf = requestAnimationFrame(function () {
            scrollRaf = null;
            var r = section.getBoundingClientRect();
            /* -1 … 1 while the section crosses the viewport */
            var progress = ((window.innerHeight / 2) - (r.top + r.height / 2)) / (r.height + window.innerHeight) * 2;
            propWraps.forEach(function (wrap, i) {
              var dir = (i % 2 === 0) ? 1 : -1;
              var spin = progress * (160 + i * 40) * dir;
              var drift = progress * (14 + (i % 3) * 16) * -1;
              wrap.style.translate = '0 ' + drift.toFixed(1) + 'px';
              var img = wrap.querySelector('img');
              if (img) img.style.transform = 'rotate(' + spin.toFixed(1) + 'deg)';
            });
          });
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      /* 3D tilt of the active look's image toward the cursor */
      if (window.matchMedia('(pointer: fine)').matches && stage) {
        var raf = null;
        stage.addEventListener('mousemove', function (e) {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            var r = stage.getBoundingClientRect();
            var mx = (e.clientX - r.left) / r.width - 0.5;
            var my = (e.clientY - r.top) / r.height - 0.5;
            var img = looks[current] && looks[current].querySelector('img, svg');
            if (img) img.style.transform = 'perspective(700px) rotateY(' + (mx * 16) + 'deg) rotateX(' + (-my * 12) + 'deg)';
          });
        });
        stage.addEventListener('mouseleave', function () {
          var img = looks[current] && looks[current].querySelector('img, svg');
          if (img) img.style.transform = '';
        });
      }
    });
  }

  /* ---------- how-it-works: animated placeholders ---------- */
  function initHowAnims() {
    /* collar with cycling colorways (step 1) */
    document.querySelectorAll('svg[data-cycle]').forEach(function (svg) {
      if (svg.dataset.bbCycleDone) return;
      svg.dataset.bbCycleDone = '1';
      var frames;
      try { frames = JSON.parse(svg.dataset.cycle); } catch (e) { return; }
      if (!frames || !frames.length) return;
      var idx = 0;
      setInterval(function () {
        var f = frames[idx % frames.length];
        idx++;
        var beads = svg.querySelectorAll('.bb-bead');
        beads.forEach(function (c, i) {
          c.setAttribute('fill', f.pal[i % f.pal.length]);
        });
        var t = svg.querySelector('.bb-tag-name');
        if (t && f.tag) t.textContent = f.tag;
      }, 2000);
    });

    /* typewriter labels (steps 2-3) */
    document.querySelectorAll('.bb-how__typed').forEach(function (el) {
      if (el.dataset.bbTypeDone) return;
      el.dataset.bbTypeDone = '1';
      var words;
      try { words = JSON.parse(el.dataset.type); } catch (e) { return; }
      if (!words || !words.length) return;
      var hold = parseInt(el.dataset.hold, 10) || 1500;
      var wi = 0, ci = 0, deleting = false;
      (function step() {
        var word = words[wi % words.length];
        if (!deleting) {
          ci++;
          el.textContent = word.slice(0, ci);
          if (ci === word.length) {
            if (words.length === 1) { setTimeout(function () { deleting = true; step(); }, hold); return; }
            deleting = true;
            setTimeout(step, hold);
            return;
          }
          setTimeout(step, 110);
        } else {
          ci--;
          el.textContent = word.slice(0, ci);
          if (ci === 0) {
            deleting = false;
            wi++;
            setTimeout(step, 450);
            return;
          }
          setTimeout(step, 55);
        }
      })();
    });
  }

  /* ---------- cart drawer: quick-add апселов (чармы) ----------
     Делегирование на document — контент дровера постоянно
     перерисовывается innerHTML-ом, прямые листенеры бы отвалились. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bb-quick-add]');
    if (!btn || btn.classList.contains('is-busy')) return;
    var drawer = document.querySelector('cart-drawer');
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var sections = drawer && drawer.getSectionsToRender
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : [];
    btn.classList.add('is-busy');
    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.bbQuickAdd), quantity: 1 }],
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.message) throw new Error(res.description || res.message);
        if (drawer) {
          drawer.classList.remove('is-empty');
          if (res.sections && drawer.renderContents) drawer.renderContents(res);
        }
        if (btn.dataset.bbCxName && window.bbCxAfterAdd) window.bbCxAfterAdd(btn.dataset.bbCxName);
      })
      .catch(function (err) { console.error('beadboo quick-add:', err); })
      .finally(function () { btn.classList.remove('is-busy'); });
  });

  /* ---------- корзина: «Add an extra charm» v2 (2026-09-10) ----------
     Страницы по 8 чипов (стрелки/точки, снап), «See all» раскрывает группы,
     лупа → <dialog> с фото витрины. Дровер перерисовывается innerHTML-ом после
     каждого добавления, поэтому состояние (раскрыто/страница) живёт в bbCxState
     и восстанавливается в initCartCharms() по мутации cart-drawer. */
  var bbCxState = { all: false, page: 0 };
  function bbCxSync(track, commit) {
    var cx = track.closest('[data-bb-cx]');
    if (!cx) return;
    var pages = track.querySelectorAll('.bb-cx__page').length;
    var i = track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
    /* после перерисовки дровера первые scroll-события — это восстановление позиции
       и снап на ещё не разложенном треке; в память их не пишем */
    if (commit !== false) bbCxState.page = i;
    var prev = cx.querySelector('[data-bb-cx-arr="-1"]'), next = cx.querySelector('[data-bb-cx-arr="1"]');
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= pages - 1;
    var dots = cx.querySelector('[data-bb-cx-dots]');
    if (dots) {
      if (dots.children.length !== pages) {
        dots.innerHTML = '';
        for (var k = 0; k < pages; k++) {
          var d = document.createElement('button');
          d.type = 'button'; d.className = 'bb-cx__dot'; d.setAttribute('data-bb-cx-dot', k); d.setAttribute('aria-label', 'Page ' + (k + 1));
          dots.appendChild(d);
        }
      }
      Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === i); });
      dots.hidden = pages < 2;
      if (prev) prev.hidden = pages < 2;
      if (next) next.hidden = pages < 2;
    }
    /* легенда «Hangs on a gold ring» (2026-09-19, Илья): только когда на экране есть чип с колечком —
       в режиме страниц смотрим текущую страницу, в режиме «See all» — весь список */
    var lg = cx.querySelector('.bb-cx__legend');
    if (lg) {
      if (bbCxState.all) lg.hidden = !cx.querySelector('[data-bb-cx-mode="all"] .bb-cx__ring');
      else { var pgEl = track.querySelectorAll('.bb-cx__page')[i]; lg.hidden = !(pgEl && pgEl.querySelector('.bb-cx__ring')); }
    }
  }
  function bbCxApplyAll(cx, all) {
    var pages = cx.querySelector('[data-bb-cx-mode="pages"]'), allEl = cx.querySelector('[data-bb-cx-mode="all"]');
    var btn = cx.querySelector('[data-bb-cx-toggle]');
    if (!pages || !allEl || !btn) return;
    allEl.hidden = !all; pages.hidden = all;
    btn.querySelector('[data-bb-cx-lbl]').textContent = all ? 'Show less' : 'See all ' + btn.dataset.bbCxCount + ' charms';
    bbCxState.all = all;
    var tr = pages.querySelector('[data-bb-cx-track]');
    if (tr) bbCxSync(tr, false); // пересчитать легенду под новый режим
  }
  function initCartCharms() {
    document.querySelectorAll('[data-bb-cx]:not([data-bb-cx-live])').forEach(function (cx) {
      cx.setAttribute('data-bb-cx-live', '1');
      var track = cx.querySelector('[data-bb-cx-track]');
      if (!track) return;
      bbCxApplyAll(cx, bbCxState.all);
      var ready = false, want = bbCxState.page;
      function restore() {
        if (want) track.scrollLeft = want * track.clientWidth;
        bbCxSync(track, false);
      }
      restore();
      requestAnimationFrame(restore);
      setTimeout(function () { restore(); ready = true; }, 350);
      track.addEventListener('scroll', function () { bbCxSync(track, ready); });
      if ('ResizeObserver' in window) new ResizeObserver(function () { bbCxSync(track, ready); }).observe(track);
    });
  }
  window.bbCxAfterAdd = function (name) {
    var msg = document.querySelector('[data-bb-cx-msg]');
    if (!msg) return;
    msg.textContent = name + ' added · $4.49';
    clearTimeout(window.bbCxAfterAdd.t);
    window.bbCxAfterAdd.t = setTimeout(function () { msg.textContent = ''; }, 2600);
  };
  document.addEventListener('click', function (e) {
    var arr = e.target.closest('[data-bb-cx-arr]');
    if (arr) {
      var tr = arr.closest('[data-bb-cx]').querySelector('[data-bb-cx-track]');
      tr.scrollBy({ left: Number(arr.dataset.bbCxArr) * tr.clientWidth, behavior: 'smooth' });
      setTimeout(function () { bbCxSync(tr); }, 400);
      return;
    }
    var dot = e.target.closest('[data-bb-cx-dot]');
    if (dot) {
      var tr2 = dot.closest('[data-bb-cx]').querySelector('[data-bb-cx-track]');
      tr2.scrollTo({ left: Number(dot.dataset.bbCxDot) * tr2.clientWidth, behavior: 'smooth' });
      return;
    }
    var tg = e.target.closest('[data-bb-cx-toggle]');
    if (tg) { bbCxApplyAll(tg.closest('[data-bb-cx]'), !bbCxState.all); return; }
    var z = e.target.closest('[data-bb-cx-zoom]');
    if (z) {
      var lb = z.closest('[data-bb-cx]').querySelector('[data-bb-cx-lb]');
      if (!lb) return;
      var lbImg = lb.querySelector('[data-bb-cx-lb-img]');
      lbImg.src = z.dataset.photo; lbImg.alt = z.dataset.name + ' charm';
      lb.dataset.front = z.dataset.photo; lb.dataset.back = z.dataset.back || '';
      /* золотые Halloween-чармы (2026-09-19, как в конструкторе): переключатель Front/Back + подпись металла */
      var seg = lb.querySelector('[data-bb-cx-lb-seg]');
      if (seg) { seg.hidden = !lb.dataset.back; seg.querySelectorAll('[data-side]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.side === 'front')); }); }
      var sub = lb.querySelector('[data-bb-cx-lb-sub]');
      if (sub) {
        if (!sub.dataset.def) sub.dataset.def = sub.innerHTML;
        sub.innerHTML = z.dataset.ring === 'gold' ? '<span class="bb-cx__ring bb-cx__ring--inline" aria-hidden="true"></span>Gold-tone edge · comes on a gold ring · $4.49'
          : z.dataset.ring === 'silver' ? 'Silver-tone ring · $4.49' : sub.dataset.def;
      }
      lb.querySelector('[data-bb-cx-lb-name]').textContent = z.dataset.name;
      var add = lb.querySelector('[data-bb-cx-lb-add]');
      add.dataset.bbQuickAdd = z.dataset.vid; add.dataset.bbCxName = z.dataset.name;
      if (typeof lb.showModal === 'function') lb.showModal(); else lb.setAttribute('open', '');
      return;
    }
    var sd = e.target.closest('[data-bb-cx-lb-seg] [data-side]');
    if (sd) {
      var lb2 = sd.closest('dialog'); var im2 = lb2.querySelector('[data-bb-cx-lb-img]');
      var toBack = sd.dataset.side === 'back' && lb2.dataset.back;
      im2.src = toBack ? lb2.dataset.back : lb2.dataset.front;
      lb2.querySelectorAll('[data-bb-cx-lb-seg] [data-side]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === sd)); });
      return;
    }
    var lbAdd = e.target.closest('[data-bb-cx-lb-add]');
    if (lbAdd) { var dlg = lbAdd.closest('dialog'); if (dlg && dlg.open) dlg.close(); return; /* сам add уйдёт через [data-bb-quick-add] */ }
    var cl = e.target.closest('[data-bb-cx-lb-close]');
    if (cl) { var dlg2 = cl.closest('dialog'); if (dlg2) dlg2.close(); return; }
    var dlg3 = e.target.closest('dialog[data-bb-cx-lb]');
    if (dlg3 && e.target === dlg3) dlg3.close();
  });
  function initCartCharmsWatch() {
    initCartCharms();
    var el = document.querySelector('cart-drawer');
    if (!el || el.hasAttribute('data-bb-cx-watch') || !('MutationObserver' in window)) return;
    el.setAttribute('data-bb-cx-watch', '1');
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(initCartCharms, 60); }).observe(el, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCartCharmsWatch); else initCartCharmsWatch();

  /* ---------- Shipping Protection: тумблер над кнопкой Checkout ----------
     Чекаут редактировать нельзя, поэтому страховка продаётся в корзине:
     тумблер добавляет/убирает скрытый товар `shipping-protection`. */
  function bbCartSectionIds() {
    var drawer = document.querySelector('cart-drawer');
    return drawer && drawer.getSectionsToRender
      ? drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      : '';
  }

  function bbCartPost(url, body) {
    body.sections = bbCartSectionIds();
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.message) throw new Error(res.description || res.message);
        return res;
      });
  }

  function bbCartApply(res) {
    /* на самой странице /cart секций для перерисовки нет — там проще перезагрузиться */
    if (document.getElementById('main-cart-footer')) { window.location.reload(); return; }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && res && res.sections && drawer.renderContents) {
      drawer.classList.remove('is-empty');
      drawer.renderContents(res);
    } else {
      window.location.reload();
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bb-prot-toggle]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    var routes = window.routes || {};
    var wasOn = btn.classList.contains('is-on');
    btn.setAttribute('aria-busy', 'true');
    /* переключаем сразу, не дожидаясь ответа — иначе тумблер «залипает» на пол-секунды */
    btn.classList.toggle('is-on', !wasOn);
    btn.setAttribute('aria-checked', String(!wasOn));

    var request = wasOn
      ? bbCartPost(routes.cart_change_url || '/cart/change', {
          id: btn.getAttribute('data-bb-prot-key'),
          quantity: 0,
        })
      : bbCartPost(routes.cart_add_url || '/cart/add', {
          items: [{ id: Number(btn.getAttribute('data-bb-prot-variant')), quantity: 1 }],
        });

    request
      .then(bbCartApply)
      .catch(function (err) {
        console.error('beadboo shipping protection:', err);
        btn.classList.toggle('is-on', wasOn);
        btn.setAttribute('aria-checked', String(wasOn));
      })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });

  /* Покупатель удалил все реальные товары, а страховка осталась одна — Liquid корзину
     менять не умеет, поэтому шаблон оставляет маркер, а вычищаем её отсюда. */
  var bbProtPurging = false;
  function bbProtPurge() {
    if (bbProtPurging) return;
    var marker = document.querySelector('[data-bb-prot-purge]');
    var key = marker && marker.getAttribute('data-bb-prot-purge');
    if (!key) return;
    var routes = window.routes || {};
    bbProtPurging = true;
    bbCartPost(routes.cart_change_url || '/cart/change', { id: key, quantity: 0 })
      .then(bbCartApply)
      .catch(function (err) { console.error('beadboo shipping protection purge:', err); })
      .finally(function () { bbProtPurging = false; });
  }

  /* корзина перерисовывается innerHTML-ом и события об этом не шлёт — смотрим мутации */
  function initProtWatch() {
    if (!('MutationObserver' in window)) return;
    ['cart-drawer', '#main-cart-footer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el || el.hasAttribute('data-bb-prot-watch')) return;
      el.setAttribute('data-bb-prot-watch', '1');
      var timer = null;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(bbProtPurge, 150);
      }).observe(el, { childList: true, subtree: true });
    });
    bbProtPurge();
  }

  /* стрелки рейла чармов в корзине (десктоп/мышь) */
  function bbRailSync(rail) {
    var wrap = rail.closest('.bb-extras__railwrap');
    if (!wrap) return;
    var maxLeft = rail.scrollWidth - rail.clientWidth - 1;
    var prev = wrap.querySelector('[data-bb-rail="prev"]');
    var next = wrap.querySelector('[data-bb-rail="next"]');
    if (prev) prev.classList.toggle('is-off', rail.scrollLeft <= 0);
    if (next) next.classList.toggle('is-off', rail.scrollLeft >= maxLeft);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bb-rail]');
    if (!btn) return;
    var wrap = btn.closest('.bb-extras__railwrap');
    var rail = wrap && wrap.querySelector('.bb-extras__rail');
    if (!rail) return;
    var step = rail.clientWidth * 0.8;
    /* без behavior:'smooth' — на снап-рейле он в части окружений молча
       не скроллит; мгновенный сдвиг снапится к ближайшей карточке */
    rail.scrollBy(btn.dataset.bbRail === 'next' ? step : -step, 0);
    /* состояния стрелок обновляем сами: событие scroll на программный
       скролл доставляется не везде; таймаут — дождаться снапа */
    setTimeout(function () { bbRailSync(rail); }, 120);
  });
  /* и по живому скроллу (палец/колесо); capture — scroll не всплывает */
  document.addEventListener('scroll', function (e) {
    var rail = e.target;
    if (!rail || !rail.classList || !rail.classList.contains('bb-extras__rail')) return;
    bbRailSync(rail);
  }, true);

  /* ---------- collection card slideshows (.bb-pcard) ----------
     Crossfades the product photos inside each catalog card. IO-gated
     (runs only in viewport), paused on hover, intervals staggered per
     column so cards don't flip in sync. Re-inits after facet filtering
     re-renders #ProductGridContainer (guarded by data-bb-live). */
  function initPcards() {
    var cards = document.querySelectorAll('[data-bb-pcard]:not([data-bb-live])');
    if (!cards.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    cards.forEach(function (card, i) {
      card.setAttribute('data-bb-live', '1');
      var imgs = card.querySelectorAll('[data-bb-slide]');
      if (imgs.length < 2 || reduce) return;
      var dots = card.querySelectorAll('[data-bb-dot]');
      var base = parseInt(card.getAttribute('data-bb-interval'), 10) || 2600;
      var idx = 0, timer = null, hover = false;
      function show(n) {
        imgs[idx].classList.remove('is-on');
        if (dots[idx]) dots[idx].classList.remove('is-on');
        idx = n % imgs.length;
        imgs[idx].classList.add('is-on');
        if (dots[idx]) dots[idx].classList.add('is-on');
      }
      function start() {
        if (timer) return;
        timer = setInterval(function () { if (!hover) show(idx + 1); }, base + (i % 4) * 350);
      }
      function stop() { clearInterval(timer); timer = null; }
      card.addEventListener('mouseenter', function () { hover = true; });
      card.addEventListener('mouseleave', function () { hover = false; });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { start(); } else { stop(); } });
        }, { threshold: 0.25 });
        io.observe(card);
      } else {
        start();
      }
    });
    var pgc = document.getElementById('ProductGridContainer');
    if (pgc && !pgc.hasAttribute('data-bb-pcard-watch') && 'MutationObserver' in window) {
      pgc.setAttribute('data-bb-pcard-watch', '1');
      new MutationObserver(function () { initPcards(); }).observe(pgc, { childList: true, subtree: true });
    }
  }

  /* ---------- photo strip (.bb-ugc-row) ----------
     ДВА режима, порог тот же 620px, что в CSS:

     • десктоп — CSS-анимация трека. Длительность считаем из ширины набора:
       duration = setWidth / (px per second), иначе длинная лента ехала бы
       быстрее короткой при одной и той же длительности.
     • мобилка — ряд это нативный горизонтальный скроллер (CSS выключает
       анимацию), а автопрокрутку ведём сами через scrollLeft. Так свайп
       пальцем и его инерция достаются системные, ничего не эмулируем.
       Позицию держим в r.pos (float): scrollLeft округляется, и приращения
       <1px за кадр просто терялись бы.

     Ряд вне вьюпорта получает класс is-paused (IntersectionObserver).
     ⚠️ Наблюдатели держим в переменных модуля: анонимный
     `new IntersectionObserver(...).observe(el)` живёт только на честном слове. */
  var BB_UGC_MOBILE_FACTOR = 1.5;   /* на мобиле фото мельче — лента должна идти бодрее */
  var BB_UGC_BREAK = 620;
  var bbUgcRows = [];
  var bbUgcIO = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.target.classList.toggle('is-paused', !e.isIntersecting); });
      }, { threshold: 0 })
    : null;

  /* Видео в ленте: <video> стоит в КАЖДОЙ карточке (иначе на мобиле в кадр не попадает
     ни одного — см. комментарий в snippets/beadboo-ugc-card.liquid), но с preload="none",
     поэтому до попадания в кадр браузер не грузит ни байта. Грузим и играем только то,
     что реально видно — иначе браузер тянет и греет все ролики сразу. */
  function bbVideoPlay(v) {
    if (v.dataset.bbOut) return;   /* пока грузилось — уехало из кадра */
    v.muted = true;                /* iOS смотрит на СВОЙСТВО, атрибута ему мало */
    var pr = v.play();
    if (pr && pr.catch) pr.catch(function () {});   /* автоплей могли запретить — не шумим */
  }

  var bbVideoIO = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            delete v.dataset.bbOut;
            if (!v.dataset.bbWarm) {          /* прогрев ровно один раз: load() сбрасывает позицию */
              v.dataset.bbWarm = '1';
              v.preload = 'auto';
              /* первый play() почти всегда отлетает «нет данных» — добиваем по canplay */
              v.addEventListener('canplay', function () { bbVideoPlay(v); });
              v.load();
            }
            bbVideoPlay(v);
          } else {
            v.dataset.bbOut = '1';
            if (!v.paused) v.pause();
          }
        });
      }, { threshold: 0.25 })
    : null;

  /* Сдвигаем позицию ровно на ширину набора — контент периодичен, поэтому скачок
     не виден. Держим ряд в середине скролла: запас на свайп есть в обе стороны. */
  function bbUgcWrap(r) {
    var s = r.setW;
    if (!s) return;
    var p = r.pos;
    if (p >= s * 1.5) p -= s;
    else if (p < s * 0.5) p += s;
    if (p !== r.pos) { r.pos = p; r.row.scrollLeft = p; }
  }

  function bbUgcStopScroll(r) {
    if (r.raf) { cancelAnimationFrame(r.raf); r.raf = null; }
  }

  function bbUgcStartScroll(r) {
    var row = r.row;
    if (!r.bound) {
      r.bound = true;
      ['touchstart', 'pointerdown'].forEach(function (e) {
        row.addEventListener(e, function () { r.touch = true; }, { passive: true });
      });
      ['touchend', 'touchcancel', 'pointerup', 'pointercancel'].forEach(function (e) {
        row.addEventListener(e, function () { r.touch = false; }, { passive: true });
      });
    }
    if (r.pos === undefined) { r.pos = r.setW; row.scrollLeft = r.pos; }
    if (r.raf || r.reduce) return;   /* reduce-motion: свайп остаётся, автопрокрутки нет */
    r.last = 0;
    /* Чужое движение ловим ОПРОСОМ scrollLeft в кадре, а не событием scroll:
       событие приходит только к отрисовке (в фоновой вкладке не приходит вовсе),
       да и своё же присвоение его поднимает. Разошлось больше чем на 2px — значит
       ведёт палец или инерция: подхватываем позицию и 150мс ничего не пишем, иначе
       на iOS присвоение scrollLeft обрывает инерцию свайпа. */
    var step = function (ts) {
      r.raf = requestAnimationFrame(step);
      var dt = r.last ? Math.min((ts - r.last) / 1000, 0.05) : 0;
      r.last = ts;
      var sl = row.scrollLeft;
      if (Math.abs(sl - r.pos) > 2) { r.pos = sl; r.userAt = ts; }
      if (r.touch || ts - (r.userAt || -1e9) < 150 || row.classList.contains('is-paused')) return;
      r.pos += r.pps * BB_UGC_MOBILE_FACTOR * dt;
      bbUgcWrap(r);
      row.scrollLeft = r.pos;
    };
    r.raf = requestAnimationFrame(step);
  }

  function bbUgcSync() {
    /* в редакторе темы секция перерисовывается — выкидываем отвалившиеся узлы */
    bbUgcRows = bbUgcRows.filter(function (r) { return r.row.isConnected !== false; });
    var narrow = window.innerWidth <= BB_UGC_BREAK;
    bbUgcRows.forEach(function (r) {
      var w = r.set.getBoundingClientRect().width;
      if (!w) return;
      r.setW = w;
      if (narrow) {
        r.track.style.animationDuration = '';
        bbUgcStartScroll(r);
      } else {
        bbUgcStopScroll(r);
        if (r.pos !== undefined) { r.pos = undefined; r.row.scrollLeft = 0; }
        if (!r.reduce) r.track.style.animationDuration = Math.round(w / r.pps) + 's';
      }
    });
  }

  function initUgc() {
    var rows = document.querySelectorAll('[data-bb-ugc]:not([data-bb-live])');
    if (!rows.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    rows.forEach(function (row) {
      row.setAttribute('data-bb-live', '1');
      var track = row.querySelector('[data-bb-ugc-track]');
      var set = row.querySelector('[data-bb-ugc-set]');
      if (!track || !set) return;
      bbUgcRows.push({
        row: row, track: track, set: set, reduce: reduce,
        pps: parseFloat(row.getAttribute('data-bb-speed')) || 22
      });
      if (bbUgcIO) bbUgcIO.observe(row);
      if (bbVideoIO && !reduce) {
        row.querySelectorAll('[data-bb-video]').forEach(function (v) { bbVideoIO.observe(v); });
      }
    });
    bbUgcSync();
    /* карточки фиксированной ширины, но шрифты/картинки догружаются — пересчёт */
    window.addEventListener('load', bbUgcSync);
    if (!window.bbUgcResize) {
      window.bbUgcResize = 1;
      var t = null;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(bbUgcSync, 200);
      });
    }
  }

  /* Автоперемотка рейла стилей (bb-sg): раз в ~3.6с листаем на карточку,
     в конце возвращаемся к началу. Пауза: hover, касание/колесо (8с),
     вне вьюпорта; reduced-motion — выключено совсем. */
  function initSgRail() {
    document.querySelectorAll('.bb-sg__grid').forEach(function (rail) {
      if (rail.dataset.bbLive) return;
      rail.dataset.bbLive = '1';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var paused = false;
      var resumeT = null;
      function pauseFor(ms) {
        paused = true;
        clearTimeout(resumeT);
        resumeT = setTimeout(function () { paused = false; }, ms);
      }
      ['pointerdown', 'wheel', 'touchstart'].forEach(function (ev) {
        rail.addEventListener(ev, function () { pauseFor(8000); }, { passive: true });
      });
      rail.addEventListener('mouseenter', function () { paused = true; });
      rail.addEventListener('mouseleave', function () { paused = false; });
      var visible = false;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { visible = e.isIntersecting; });
        }, { threshold: 0.25 }).observe(rail);
      } else {
        visible = true;
      }
      setInterval(function () {
        if (paused || !visible || document.hidden) return;
        var card = rail.querySelector('.bb-sg__card');
        if (!card) return;
        var step = card.getBoundingClientRect().width + 18;
        var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 24;
        if (atEnd) rail.scrollTo({ left: 0, behavior: 'smooth' });
        else rail.scrollBy({ left: step, behavior: 'smooth' });
      }, 3600);
    });
  }


  /* Видеоряд-сторис (bb-reels): (1) автопрокрутка ряда — независимо от того,
     залиты видео или пока стоят постеры; (2) видео стартует только во вьюпорте
     и встаёт на паузу за его пределами (preload='none' в разметке, поэтому до
     первого показа ничего не грузится). */
  function bbReelsAutoscroll(rail) {
    /* Плавная непрерывная лента (Илья, 2026-08-17: скачки «очень резкие»).
       Вместо scrollBy на карточку раз в N секунд лента едет постоянно со
       скоростью speed px/сек (настройка секции). Контент дублируется, пока не
       наберётся двойная ширина, и позиция заворачивается на половине — стык
       не виден, потому что вторая половина идентична первой. */
    var speed = parseFloat(rail.dataset.speed || 0);
    if (!speed || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var originals = [].slice.call(rail.children);
    if (!originals.length) return;

    /* Лента не «выскакивает»: снимаем reveal-анимацию с карточек. Клоны
       создаются после initReveal, их никто не наблюдает — на них класс bb-rv
       оставлял бы opacity:0 навсегда (Илья, 2026-08-17). Лента просто едет. */
    originals.forEach(function (el) { el.classList.remove('bb-rv', 'bb-d1', 'bb-d2', 'bb-d3'); });

    /* scroll-snap возвращал ленту к ближайшей карточке и съедал субпиксельный
       шаг — в плавном режиме снап выключаем (иначе лента стоит на месте). */
    rail.style.scrollSnapType = 'none';

    /* дублируем набор, пока лента не станет минимум вдвое шире экрана */
    var guard = 0;
    while (rail.scrollWidth < rail.clientWidth * 2 + 200 && guard < 12) {
      originals.forEach(function (el) {
        var c = el.cloneNode(true);
        c.classList.remove('bb-rv', 'bb-d1', 'bb-d2', 'bb-d3');
        rail.appendChild(c);
      });
      guard++;
    }
    /* и ещё один набор — это та самая «вторая половина» для заворота */
    var half = rail.scrollWidth;
    [].slice.call(rail.children).forEach(function (el) {
      var c = el.cloneNode(true);
      c.classList.remove('bb-rv', 'bb-d1', 'bb-d2', 'bb-d3');
      rail.appendChild(c);
    });

    var paused = false, resumeT = null, visible = false;
    var pos = 0, last = 0;

    function hold(ms) {
      paused = true;
      clearTimeout(resumeT);
      resumeT = setTimeout(function () { pos = rail.scrollLeft; paused = false; }, ms);
    }
    ['pointerdown', 'wheel', 'touchstart'].forEach(function (ev) {
      rail.addEventListener(ev, function () { hold(6000); }, { passive: true });
    });
    rail.addEventListener('mouseenter', function () { paused = true; });
    rail.addEventListener('mouseleave', function () { pos = rail.scrollLeft; paused = false; });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { visible = e.isIntersecting; });
      }, { threshold: 0.15 }).observe(rail);
    } else {
      visible = true;
    }

    function frame(ts) {
      var dt = last ? Math.min(ts - last, 64) : 0;   /* защита от прыжка после вкладки */
      last = ts;
      if (!paused && visible && !document.hidden) {
        pos += speed * dt / 1000;
        if (pos >= half) pos -= half;                /* бесшовный заворот */
        rail.scrollLeft = pos;
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function bbReelsVideo(rail) {
    var vids = [].slice.call(rail.querySelectorAll('video'));
    if (!vids.length) return;
    vids.forEach(function (v) {
      v.muted = true;              /* Safari требует muted ДО play() */
      v.playsInline = true;
      v.loop = true;
      v.setAttribute('muted', '');
    });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.preload === 'none') v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.4 });
    vids.forEach(function (v) { io.observe(v); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) vids.forEach(function (v) { v.pause(); });
    });
  }

  function initReels() {
    document.querySelectorAll('[data-bb-reels]').forEach(function (rail) {
      if (rail.dataset.bbDone) return;
      rail.dataset.bbDone = '1';
      bbReelsAutoscroll(rail);
      bbReelsVideo(rail);
    });
  }

  /* «Чистые» карточки стилей (.bb-scard, сетка /collections/original-styles):
     hover листает фото-слои по кругу — «наводишь мышку → следующие фотографии»
     (Илья 2026-08-25). Слои строит beadboo-card-clean.liquid; без JS (и на
     тач-экранах без hover) виден первый слой. reduced-motion: только второй
     кадр без цикла. */
  function initScards() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-bb-scard]').forEach(function (pic) {
      var imgs = pic.querySelectorAll('.bb-scard__img');
      if (imgs.length < 2) return;
      var idx = 0;
      var timer = null;
      function show(i) {
        idx = (i + imgs.length) % imgs.length;
        imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === idx); });
      }
      var card = pic.closest('.bb-scard') || pic;
      card.addEventListener('mouseenter', function () {
        if (timer) return;
        show(1); // сразу следующий кадр, дальше — по кругу
        if (reduce) return;
        timer = setInterval(function () { show(idx + 1); }, 1100);
      });
      card.addEventListener('mouseleave', function () {
        if (timer) { clearInterval(timer); timer = null; }
        show(0);
      });
    });
  }

  /* Видео-«анимации» галереи товара (.bb-media-anim, 2026-08-25, Илья):
     звук выключен намертво (страховка против атрибут-потерь при перерисовках
     Dawn), играет только во вьюпорте, reduced-motion — стоп-кадр (постер). */
  function initMediaAnim() {
    var vids = Array.prototype.slice.call(document.querySelectorAll('.bb-media-anim video'));
    if (!vids.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    vids.forEach(function (v) {
      v.muted = true;
      v.defaultMuted = true;
      v.controls = false;
      v.addEventListener('volumechange', function () { if (!v.muted) v.muted = true; });
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
    });
    if (reduce) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) vids.forEach(function (v) { v.pause(); });
    });
  }


  /* ---------- reviews carousel (beadboo-testimonials, 2026-08-27) ----------
     Ручная карусель: стрелки листают на ширину карточки+gap, состояние
     disabled обновляется по фактическому scrollLeft. Свайп — нативный
     scroll-snap, JS его не трогает. */
  function initTcar() {
    document.querySelectorAll('[data-bb-tcar]').forEach(function (root) {
      if (root.dataset.bbTcarReady) return;
      root.dataset.bbTcarReady = '1';
      var track = root.querySelector('[data-bb-tcar-track]');
      var prev = root.querySelector('[data-bb-tcar-prev]');
      var next = root.querySelector('[data-bb-tcar-next]');
      if (!track || !prev || !next) return;

      function step() {
        var card = track.querySelector('.bb-tcar__card');
        if (!card) return 340;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 22;
        return card.getBoundingClientRect().width + gap;
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function initAll() {
    initReveal();
    initCollars();
    initHeroBeads();
    initParallax();
    initFlipTag();
    initLooks();
    initFly();
    initHowAnims();
    initPcards();
    initScards();
    initMediaAnim();
    initUgc();
    initReels();
    initProtWatch();
    initTcar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  /* re-run inside the theme editor when sections re-render */
  document.addEventListener('shopify:section:load', initAll);
})();

/* ---------- handmade: ленивое видео сборки ----------
   Видео помечено preload="none" и без autoplay: до доскролла браузер качает
   только постер (первый кадр), страница не тормозит. Как только секция попала
   во вьюпорт — включаем воспроизведение автоматически (muted + playsinline,
   поэтому автоплей разрешён во всех браузерах). Кнопки Play нет: видео всегда
   играет само. За окном вьюпорта ставим на паузу, чтобы не жечь батарею. */
(function () {
  var boxes = document.querySelectorAll('.bb-hm-video');
  if (!boxes.length) return;

  Array.prototype.forEach.call(boxes, function (box) {
    var video = box.querySelector('video');
    if (!video) return;

    function play() {
      video.muted = true;
      video.preload = 'auto';
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* автоплей заблокирован — остаётся постер */ });
    }

    if (!('IntersectionObserver' in window)) { play(); return; }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) play();
        else if (!video.paused) video.pause();
      });
    }, { threshold: 0.35 }).observe(box);
  });
})();

/* ---------- видео: только автоплей без звука, никакого «плеера» (Илья, 2026-08-22) ----------
   Задача: ролик в секции — это фон, а не файл, который можно открыть, закрыть,
   включить звук или отправить в PiP/на телек. Разметку из Liquid тут не поправить:
   `video_tag` умеет только известные ему параметры (controls/muted/loop/...) и
   произвольные атрибуты не отдаёт, поэтому вешаем их из JS.
   Клики уже гасит CSS (pointer-events:none) — здесь второй эшелон:
   • controlsList / disablePictureInPicture / disableremoteplayback — убирают то,
     до чего можно добраться мимо мыши (меню браузера, AirPlay, Cast, клавиатура);
   • volumechange — если звук всё же включили (расширение, восстановление сессии),
     тут же возвращаем mute;
   • WeakSet вместо data-атрибута: карусель reels клонирует карточки, а клон
     унаследовал бы data-флаг «уже обработан» и остался бы без слушателей. */
(function () {
  var BB_VID_SEL = '.bb-reel__video, .bb-reel__frame video, .bb-hm-video video, ' +
                   '.bb-flipvid video, .bb-ugc-shot video, [data-bb-video]';
  var locked = (typeof WeakSet === 'function') ? new WeakSet() : null;

  function lock(v) {
    if (v.tagName !== 'VIDEO') return;
    if (locked) { if (locked.has(v)) return; locked.add(v); }
    v.controls = false;
    v.removeAttribute('controls');
    v.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback noplaybackrate');
    v.setAttribute('disableremoteplayback', '');
    v.disableRemotePlayback = true;
    v.disablePictureInPicture = true;
    v.defaultMuted = true;
    v.muted = true;
    v.tabIndex = -1;
    v.setAttribute('aria-hidden', 'true');
    v.addEventListener('volumechange', function () {
      if (!v.muted) v.muted = true;
    });
  }

  function lockAll() {
    Array.prototype.forEach.call(document.querySelectorAll(BB_VID_SEL), lock);
  }

  /* сразу + ещё раз после старта каруселей (их клоны появляются в том же тике) */
  function run() { lockAll(); setTimeout(lockAll, 0); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);

  /* делегированно — накрывает и клоны карусели, и всё, что подгрузится позже */
  document.addEventListener('contextmenu', function (e) {
    var t = e.target;
    if (t && t.tagName === 'VIDEO' && t.closest && t.closest(BB_VID_SEL)) e.preventDefault();
  });
})();

/* ── Hero: слайд-шоу (Илья 2026-09-19) ──
   Кадры 2 и 3 лежат поверх первого; каждые data-bb-hero-ms мс переключаем .is-on.
   Первый кадр (в потоке) гасим классом is-off, чтобы не просвечивал.
   Пары d/m идут в DOM подряд, поэтому берём их как есть — CSS сам покажет нужную. */
(function () {
  var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mq && mq.matches) return;
  document.querySelectorAll('.bb-heroF__pic--slides').forEach(function (pic) {
    var base = pic.querySelectorAll('.bb-heroF__img:not(.bb-heroF__img--slide)');
    var slides = pic.querySelectorAll('.bb-heroF__img--slide');
    if (!slides.length) return;
    var groups = [];                       // [[d,m], [d,m], …] для кадров 2..n
    for (var i = 0; i < slides.length; i += 2) groups.push([slides[i], slides[i + 1]].filter(Boolean));
    var ms = parseInt(pic.dataset.bbHeroMs, 10) || 2000;
    var idx = 0, total = groups.length + 1, timer = null;
    function show(n) {
      base.forEach(function (el) { el.classList.toggle('is-off', n !== 0); });
      groups.forEach(function (g, gi) {
        g.forEach(function (el) { el.classList.toggle('is-on', gi === n - 1); });
      });
    }
    function tick() { idx = (idx + 1) % total; show(idx); }
    function start() { if (!timer) timer = setInterval(tick, ms); }
    function stop() { clearInterval(timer); timer = null; }
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  });
})();
